import angular from 'angular';

import './overlay.style.scss';

export const OverlayComponent = {
  selector: 'overlay',
  transclude: true,
  template: /* html */ `
    <div class="overlay">
      <div class="overlay-inner" ng-transclude></div>
    </div>
  `,
};

export default angular.module('autoboard.overlay', [])
  .component(OverlayComponent.selector, OverlayComponent)
  .name;
